import { fetchTeaching } from '@/services/sheets'

export default {
    namespaced: true,

    state: () => ({
        items: [],
        loading: false,
        loaded: false,
    }),

    getters: {
        all: state => state.items,
        active: state => state.items.filter(c => c.isActive),
    },

    mutations: {
        SET_ITEMS(state, items) { state.items = items },
        SET_LOADING(state, val) { state.loading = val },
        SET_LOADED(state, val) { state.loaded = val },
    },

    actions: {
        async fetch({ commit, state }) {
            if (state.loaded) return
            commit('SET_LOADING', true)
            try {
                const data = await fetchTeaching()
                commit('SET_ITEMS', data)
                commit('SET_LOADED', true)
            } catch (e) {
                console.error('[Store:teaching]', e)
            } finally {
                commit('SET_LOADING', false)
            }
        }
    }
}
